import * as _ from 'lodash';
import { getMomentFromHippoDateString } from 'common/source/utilities/dates';
import { maxPaymentsPerPage, paymentMethodDisplayName } from './enums';

export function getPageList(lastPage: number): Array<number> {
    const pageList = [];
    for (let i = 0; i < lastPage; i++) {
        pageList.push(i);
    }
    // page list is not shown when there is only one page
    return pageList.length > 1 ? pageList : [];
}

export function getPaginatedPastPayments(payments: Array<PastCharge>): Array<Array<PastCharge>> {
    const paginatedPayments: Array<Array<PastCharge>> = [];
    let singlePage: Array<PastCharge> = [];

    _.map(payments, (payment) => {
        if (singlePage.length === maxPaymentsPerPage) {
            paginatedPayments.push(singlePage);
            singlePage = [];
        }
        singlePage.push(payment);
    });

    if (singlePage.length) {
        paginatedPayments.push(singlePage);
    }

    return paginatedPayments;
}

export function getPaginatedUpcomingPayments(payments: UpcomingPayments): Array<UpcomingPayments> {
    const paginatedPayments: Array<UpcomingPayments> = [];
    let singlePage: Array<UpcomingPayment> = [];

    _.map(payments, (payment) => {
        if (singlePage.length === maxPaymentsPerPage) {
            paginatedPayments.push(singlePage);
            singlePage = [];
        }
        singlePage.push(payment);
    });

    if (singlePage.length) {
        paginatedPayments.push(singlePage);
    }

    return paginatedPayments;
}

export function getSortedUpcomingPaymentsAscending(policyInfo: CustomerPolicyInfo): UpcomingPayments {
    const upcomingPayments = policyInfo.payments.filter((upcomingPayment: UpcomingPayment) => {
        return !upcomingPayment.paid;
    });

    return _.orderBy(
        upcomingPayments,
        (upcomingPayment) => {
            return getMomentFromHippoDateString(upcomingPayment.date).valueOf();
        },
        ['asc']
    );
}

export function getSortedPastPaidPaymentsAscending(policyInfo: CustomerPolicyInfo): Array<PastCharge> {
    const charges = policyInfo.charges
        .filter((charge: Charge) => {
            return charge.result;
        })
        .map(
            (charge: Charge): PastCharge => {
                return {
                    date: charge.charged_at,
                    sum: charge.sum,
                    paymentMethod: charge.payment_method
                        ? paymentMethodDisplayName[charge.payment_method]
                        : charge.payment_method
                };
            }
        );

    return _.orderBy(
        charges,
        (pastCharge) => {
            return getMomentFromHippoDateString(pastCharge.date).valueOf();
        },
        ['asc']
    );
}
